//
import AccountConciliationRoutes from './AccAccountConciliationRoutes'
import AccountRoutes from './AccAccount'
import AccountingNotesRoutes from './accounting-notes'
import AccountingRecordsRoutes from './accounting-records'
import BankCardConciliationRoutes from './AccBankCardConciliation'
import CostCentersRoutes from './cost-centers'
import AccDailyLedgerRoutes from './AccDailyLedger'
import AccEightColumnsBalanceRoutes from './AccEightColumnsBalance'
import LedgerRoutes from './ledger'
import PurchaseSaleBookRoutes from './purchase-sale-book'

//
import AccountingBankCardRoutes from './AccAccountingBankCard'
import AccAccountingSeatConceptRoutes from './AccAccountingSeatConcept'

//
export default [
  AccAccountingSeatConceptRoutes,
  AccountConciliationRoutes,
  AccountRoutes,
  AccountingBankCardRoutes,
  AccountingNotesRoutes,
  AccountingRecordsRoutes,
  BankCardConciliationRoutes,
  CostCentersRoutes,
  AccDailyLedgerRoutes,
  AccEightColumnsBalanceRoutes,
  LedgerRoutes,
  PurchaseSaleBookRoutes,
]
